module.exports = __webpack_public_path__ + "img/画板 4@3x.cfdb48c5.png";